import React, { createContext, useState, useEffect } from "react";
import { isEmpty } from "lodash";
import { useLocation } from "react-router-dom";
import { apiGet, apiPost } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import moment from "moment";
import { useContext } from "react";
import AuthProvider from "./AuthContext";

const BetSlipContext = createContext();

export default BetSlipContext;

export const BetSlipProvider = ({ children }) => {
  const location = useLocation();
  let { user, setLoader, profileData, amounutRefresh } =
    useContext(AuthProvider);
  const [refreshCurrentBet, setRefreshCurrentBets] = useState(false);
  let [loading, setLoading] = useState(false);
  const [bookposition, setBookPosition] = useState(false);
  const [bookpositionData, setBookPositionData] = useState("");
  const [defaultStake, setDefaultStake] = useState("");
  const [defaultOdds, setDefaultOdds] = useState(false);
  const [betPlaceBeforeCheck, setBetPlaceBeforeCheck] = useState(false);
  const [loaderCount, setLoaderCount] = useState(7);
  const [betDelay, setBetDelay] = useState(false);
  const [updatePosition, setUpdatePosition] = useState(false);
  // const [matchLastOdds, setMatchLastOdds] = useState([]);
  const [betSelectionObj, setBetSelectionObj] = useState({
    bidPrice: "",
    inputType: "",
    betType: "",
    oddsSelect: "",
    priceToogleType: "",
    priceToogle: false,
    layorback: "",
    minAmount: 1,
    maxAmount: 100,
    minAmountText: false,
    expectany: defaultOdds,
    gameType: "",
  });
  const [messaageBox, setMessageBox] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [loaderPlaceBetfair, setLoaderPlaceBetFair] = useState(false);
  const [multiMarketEventId, setMultiMarketEventId] = useState(null);
  const [isBetPlaced, setIsBetPlaced] = useState("");
  useEffect(() => {
    setBetSelectionObj({
      bidPrice: defaultStake ? defaultStake : "",
      inputType: "",
      betType: "",
      oddsSelect: "",
      priceToogleType: "",
      priceToogle: false,
      layorback: "",
      minAmount: 1,
      maxAmount: 100,
      minAmountText: false,
      expectany: defaultOdds,
      gameType: "",
    });
  }, [location]);
  const [betLoader, setBetLoader] = useState(false);
  const [betPlacedCheck, setBetPlacedCheck] = useState(false);
  const [betfairObj, setBetFairObj] = useState({ betPopup: false });
  const [multimarketLoader, setMultimarketLoader] = useState(false);
  const [unMatchedBets, setUnmacthedBets] = useState([]);
  const [umMachedBetPlace, setUnMatchedBetPlace] = useState(false);
  const [resetBetPosition, setResetBetPosition] = useState(false);
  // console.log(profileData)
  const getCurrentBets = async () => {
    if (!isEmpty(user)) {
      const { status, data: response_users } = await apiGet(
        apiPath.unMatchedBets
      );
      if (status === 200) {
        if (response_users.success) {
          setUnmacthedBets(response_users.results);
        }
      }
    }
  };
  useEffect(() => {
    if (refreshCurrentBet) {
      getCurrentBets();
      setRefreshCurrentBets(false);
    }
  }, [refreshCurrentBet]);

  const handelPlaceBetfair = async (obj) => {
    const placement = obj || betfairObj;
    if (!isEmpty(user) && betSelectionObj?.bidPrice != "") {
      setBetFairObj({ ...placement, betPopup: false });

      if (
        Number(
          placement?.check == "lay"
            ? (
                Number(betSelectionObj?.oddsSelect) *
                  Number(betSelectionObj?.bidPrice) -
                Number(betSelectionObj?.bidPrice)
              )?.toFixed(2)
            : (
                Number(betSelectionObj?.oddsSelect - 1) *
                Number(betSelectionObj?.bidPrice)
              )?.toFixed(2)
        ) > Number(placement?.maxProfit)
      ) {
        setIsBetPlaced("maxProfitError");
        setMessageBox(true);
        setBetSelectionObj({
          ...betSelectionObj,
          priceToogle: false,
        });
        setBetLoader(true);
        setBetPlacedCheck(true);
      } else {
        setBetDelay(true);
        setBetPlaceBeforeCheck(true);
        setLoader(true);
        setLoaderPlaceBetFair(true);
        const date = moment(new Date()).format("YYYY-MM-DD, h:mm:ss");
        console.log(placement)
        console.log(betSelectionObj)
        const placeFunc = async () => {
          let result = {
            eventId: placement.eventId,
            marketId: placement.marketId,
            selectionId: placement.selectionId,
            betType: placement.check,
            bhav: betSelectionObj.oddsSelect,
            amount: betSelectionObj.bidPrice,
            version: "v1"
            // betPlaceTime: date,
            // betPlaceType: "betfair",
            // bet: [
            //   {
            //     selectionId: betfairObj.selectionId,
            //     teamName: betfairObj.teamName,
            //     bhav: betSelectionObj.oddsSelect,
            //     amount: betSelectionObj.bidPrice,
            //     betType: betfairObj.check,
            //   },
            // ],
          };
          // if (!isEmpty(user)) {
          //   const { data: response_users2 } = await apiPost(
          //     apiPath.beforeBetPlace,
          //     result
          //   );
          //   if (response_users2?.success) {
              const { status, data: response_users } = await apiPost(
                apiPath.betfairPlaceBet,
                result
              );
              if (status === 200) {
                if (response_users?.results?.matchedFlag) {
                  if (response_users?.status) {
                    console.log("betfair matched")
                    setIsBetPlaced("placed");
                    setBetPlacedCheck(true);
                    setRefreshCurrentBets(true);
                    setBetFairObj({ ...placement, betPopup: false });
                    setBetSelectionObj({
                      ...betSelectionObj,
                      priceToogle: false,
                    });
                    amounutRefresh();
                    setBetDelay(false);
                    setLoader(false);
                    setMessageBox(true);
                  } else {
                    console.log("betfair unmatched Response:", response_users);
                    setIsBetPlaced("error");
                    setBetSelectionObj({
                      ...betSelectionObj,
                      priceToogle: false,
                      errorMessage: response_users?.message || response_users?.data?.message || "!",
                    });
                    setLoader(false);
                    setBetPlacedCheck(true);
                    setMessageBox(true);
                    setBetDelay(false);
                  }
                } else {
                  setIsBetPlaced("unMatched");
                  setBetFairObj({ ...placement, betPopup: false });
                  setBetSelectionObj({
                    ...betSelectionObj,
                    priceToogle: false,
                  });
                  setLoader(false);
                  setBetPlacedCheck(true);
                  setMessageBox(true);
                  setBetDelay(false);
                }
              } else {
                console.log("400 Error Response:", response_users);
                setBetFairObj({ ...placement, betPopup: false });
                setBetSelectionObj({
                  ...betSelectionObj,
                  priceToogle: false,
                  errorMessage: response_users?.message || response_users?.data?.message || "!",
                });
                setLoader(false);
                setBetPlacedCheck(true);
                setMessageBox(true);
                setIsBetPlaced("error");
                setBetDelay(false);
              }
            // } else {
            //   setBetFairObj({ ...betfairObj, betPopup: false });
            //   setBetSelectionObj({
            //     ...betSelectionObj,
            //     priceToogle: false,
            //     errorMessage: response_users2.message,
            //   });
            //   setLoader(false);
            //   setBetPlacedCheck(true);
            //   setIsBetPlaced("error");
            //   setMessageBox(true);
            //   setBetDelay(false);
            // }
          // }
        };
        // Use betDelay from obj parameter or default to loaderCount
        const configuredDelay = Number(placement?.betDelay);
        const delaySeconds = placement?.betDelay != null && Number.isFinite(configuredDelay) && configuredDelay >= 0
          ? Math.max(1, configuredDelay)
          : (loaderCount > 1 ? loaderCount : 1);
        setTimeout(
          async () => {
            try {
              await placeFunc();
            } catch (error) {
              setIsBetPlaced("error");
              setBetPlacedCheck(true);
              setMessageBox(true);
              setBetSelectionObj({
                ...betSelectionObj,
                priceToogle: false,
                errorMessage: error?.response?.data?.message || "Unable to confirm placement. Check your bets before retrying.",
              });
            } finally {
              setLoader(false);
              setLoaderPlaceBetFair(false);
              setBetDelay(false);
            }
          },
          (delaySeconds - 1) * 1000
        );
      }
      setBetLoader(false);
      setShowLogin(true);
    }
    setBetLoader(false);
  };
  const handelPlaceToss = async (obj) => {
    const date = moment(new Date()).format("YYYY-MM-DD, h:mm:ss");
    const resultData = {
      eventId: obj?.eventId,
      marketId: obj?.marketId,
      selectionId: obj?.selectionId,
      betPlaceTime: date,
      bhav: betSelectionObj?.oddsSelect,
      amount: betSelectionObj?.bidPrice,
      teamName: obj?.teamName,
      tossMarketId: obj?.tossMarketId,
    };
    if (!isEmpty(user)) {
      const placeFunc = async () => {
        const { data: response_users2 } = await apiPost(
          apiPath.beforeBetPlace,
          resultData
        );
        if (response_users2?.success) {
          const { status, data: response_users } = await apiPost(
            apiPath.tossBetPlace,
            resultData
          );
          if (status === 200) {
            if (response_users.success) {
              setBetLoader(true);
              setBetFairObj({
                ...betfairObj,
                check: "back",
                teamName: obj?.teamName,
                betPopup: false,
              });
              setBetPlacedCheck(true);
              setBetSelectionObj({
                ...betSelectionObj,
                priceToogle: false,
              });
              setIsBetPlaced("placed");
              setLoader(false);
              setMessageBox(true);
              amounutRefresh();
              setBetLoader(false);
            } else {
              setBetFairObj({
                ...betfairObj,
                check: "back",
                teamName: obj?.teamName,
                betPopup: false,
              });
              setBetPlacedCheck(true);
              setBetSelectionObj({
                ...betSelectionObj,
                priceToogle: false,
                errorMessage: response_users?.message || response_users?.data?.message || "!",
              });
              setMessageBox(true);
              setBetLoader(false);
              setLoader(false);
              setIsBetPlaced("error");
            }
          } else {
            setBetFairObj({
              ...betfairObj,
              check: "back",
              teamName: obj?.teamName,
              betPopup: false,
            });
            setBetPlacedCheck(true);
            setBetSelectionObj({
              ...betSelectionObj,
              priceToogle: false,
              errorMessage: response_users?.message || response_users?.data?.message || "!",
            });
            setMessageBox(true);
            setBetLoader(false);
            setLoader(false);
            setIsBetPlaced("error");
          }
        } else {
          setBetFairObj({
            ...betfairObj,
            check: "back",
            teamName: obj?.teamName,
            betPopup: false,
          });
          setBetSelectionObj({
            ...betSelectionObj,
            priceToogle: false,
            errorMessage: response_users2?.message || response_users2?.data?.message || "!",
          });
          setBetPlacedCheck(true);
          setMessageBox(true);
          setBetLoader(false);
          setLoader(false);
          setIsBetPlaced("error");
        }
      };
      // Use betDelay from obj parameter or default to loaderCount
      const delaySeconds = obj?.betDelay > 1 ? obj.betDelay : (loaderCount > 1 ? loaderCount : 1);
      setTimeout(
        () => {
          placeFunc();
        },
        (delaySeconds - 1) * 1000
      );
    }
    setBetLoader(false);
  };
  const handelPlaceTie = async (obj) => {
    const date = moment(new Date()).format("YYYY-MM-DD, h:mm:ss");
    setBetDelay(true);
    setLoader(true);
    let result = {
      eventId: obj.eventId,
      marketId: obj?.tieMarketId,
      betPlaceTime: date,
      betPlaceType: "tie",
      bet: [
        {
          selectionId: obj.selectionId,
          teamName: obj.teamName,
          bhav: betSelectionObj.oddsSelect,
          amount: betSelectionObj.bidPrice,
          betType: obj.check,
        },
      ],
    };
    if (!isEmpty(user)) {
      const { data: response_users2 } = await apiPost(
        apiPath.beforeBetPlace,
        result
      );
      if (response_users2?.success) {
        const { status, data: response_users } = await apiPost(
          apiPath.tieBetPlace,
          result
        );
        if (status === 200) {
          if (response_users.success) {
            setBetLoader(true);
            setBetFairObj({
              ...betfairObj,
              check: "back",
              teamName: obj?.teamName,
              betPopup: false,
            });
            setBetPlacedCheck(true);
            setBetSelectionObj({
              ...betSelectionObj,
              priceToogle: false,
            });
            setIsBetPlaced("placed");
            setLoader(false);
            setMessageBox(true);
            amounutRefresh();
            setBetLoader(false);
          } else {
            setBetFairObj({
              ...betfairObj,
              check: "back",
              teamName: obj?.teamName,
              betPopup: false,
            });
            setBetPlacedCheck(true);
            setBetSelectionObj({
              ...betSelectionObj,
              priceToogle: false,
              errorMessage: response_users?.message || response_users?.data?.message || "!",
            });
            setMessageBox(true);
            setBetLoader(false);
            setLoader(false);
            setIsBetPlaced("error");
          }
        } else {
          setBetFairObj({
            ...betfairObj,
            check: "back",
            teamName: obj?.teamName,
            betPopup: false,
          });
          setBetSelectionObj({
            ...betSelectionObj,
            priceToogle: false,
            errorMessage: response_users?.message || response_users?.data?.message || "!",
          });
          setMessageBox(true);
          setBetLoader(false);
          setLoader(false);
          setIsBetPlaced("error");
        }
      } else {
        setBetFairObj({
          ...betfairObj,
          check: "back",
          teamName: obj?.teamName,
          betPopup: false,
        });
        setBetSelectionObj({
          ...betSelectionObj,
          priceToogle: false,
          errorMessage: response_users2?.message || response_users2?.data?.message || "!",
        });
        setMessageBox(true);
        setBetLoader(false);
        setLoader(false);
        setIsBetPlaced("error");
      }
    }
    setBetLoader(false);
  };
  const handelPlaceBetfairUpdate = async (obj) => {
    if (!isEmpty(user)) {
      setLoader(true);
      setLoaderPlaceBetFair(true);
      const date = moment(new Date()).format("YYYY-MM-DD, h:mm:ss");
      let result = {
        eventId: obj.eventId,
        marketId: obj.marketId,
        betPlaceTime: date,
        bet: [
          {
            selectionId: obj.selectionId,
            teamName: obj.teamName,
            bhav: betSelectionObj.oddsSelect,
            amount: betSelectionObj.bidPrice,
            betType: obj.betType,
          },
        ],
      };
      if (!isEmpty(user)) {
        const { status2, data: response_users2 } = await apiGet(
          `${apiPath.clearBets}matchBetId=${obj.matchBetId}`
        );

        const { status, data: response_users } = await apiPost(
          apiPath.betfairPlaceBet,
          result
        );
        if (status === 200) {
          if (response_users.results.matchedFlag) {
            if (response_users.success) {
              setIsBetPlaced("placed");
              setUnMatchedBetPlace(true);
              setBetPlacedCheck(true);
              setLoader(false);
              // getCurrentBets();
              setMessageBox(true);
              setRefreshCurrentBets(true);
              setBetLoader(true);
              setBetFairObj({ ...betfairObj, betPopup: false });
              setBetSelectionObj({
                ...betSelectionObj,
                priceToogle: false,
              });
              amounutRefresh(); // Update balance after successful bet placement
              setBetLoader(false);
              // toast.success(response_users.message);
            } else {
              setBetPlacedCheck(true);
              setMessageBox(true);
              // setRefreshCurrentBets(true);
              setUnMatchedBetPlace(true);
              getCurrentBets();
              setIsBetPlaced("error");
              setBetSelectionObj({
                ...betSelectionObj,
                priceToogle: false,
                errorMessage: response_users?.message || response_users?.data?.message || "!",
              });
              // toast.error(response_users.message);
            }
          } else {
            setIsBetPlaced("unMatched");
            setBetPlacedCheck(true);
            setLoader(false);
            getCurrentBets();
            setMessageBox(true);
            setUnMatchedBetPlace(true);
            // setRefreshCurrentBets(true);
            setBetLoader(true);
            setBetFairObj({ ...betfairObj, betPopup: false });
            setBetSelectionObj({
              ...betSelectionObj,
              priceToogle: false,
            });
            amounutRefresh(); // Update balance after bet placement
            setBetLoader(false);
          }
        } else {
          console.log(response_users?.message )
          setBetFairObj({ ...betfairObj, betPopup: false });
          setBetSelectionObj({
            ...betSelectionObj,
            priceToogle: false,
            errorMessage: response_users?.message || response_users?.data?.message || "!",
          });
          // setRefreshCurrentBets(true);
          getCurrentBets();
          setUnMatchedBetPlace(true);
          setBetPlacedCheck(true);
          setMessageBox(true);
          setIsBetPlaced("error");
        }
      } else {
        setBetLoader(false);
        getCurrentBets();
        setUnMatchedBetPlace(true);
        setLoader(false);
        setShowLogin(true);
      }
    }
    setBetLoader(false);
    setLoader(false);
  };
  const handelPlaceFancyBet = async (obj) => {
    const date = moment(new Date()).format("YYYY-MM-DD, h:mm:ss");
    setLoader(true);
    const resultData = {
      eventId: obj?.eventId,
      market_id: obj?.marketId,
      centralizedId: obj?.centralizedId,
      selectionId: obj?.selectionId,
      betPlaceTime: date,
      fancyName: obj?.fancyName,
      bhav: obj?.pt,
      amount: betSelectionObj?.bidPrice,
      betType: betSelectionObj?.layorback == "back" ? "Yes" : "No",
      // exceptAny: betSelectionObj.expectany,
      betRun: obj?.rt,
      runnerName: obj?.runnerName,
      // betPlaceType: "fancy",
      game_type: obj?.eventType ? Number(obj?.eventType) : ""
    };

    if (!isEmpty(user)) {
      if (
        Number(
          betfairObj?.check == "lay"
            ? (
                Number(betSelectionObj?.oddsSelect) *
                  Number(betSelectionObj?.bidPrice) -
                Number(betSelectionObj?.bidPrice)
              )?.toFixed(2)
            : (
                Number(betSelectionObj?.oddsSelect - 1) *
                Number(betSelectionObj?.bidPrice)
              )?.toFixed(2)
        ) > Number(betfairObj?.maxProfit?.toFixed(2))
      ) {
        setIsBetPlaced("maxProfitError");
        setMessageBox(true);
        setBetFairObj({ ...betfairObj, betPopup: false });
        setBetSelectionObj({
          ...betSelectionObj,
          priceToogle: false,
        });
        setBetLoader(true);
        setBetPlacedCheck(true);
      } else {
        const placeFunc = async () => {
          // const { data: response_users2 } = await apiPost(
          //   apiPath.beforeBetPlace,
          //   resultData
          // );
          // if (response_users2.success) {
            let api =
              obj?.fancyType == "diamond"
                ? apiPath.diamondfancyBetPlace
                : apiPath.fancyBetPlace;
            const { status, data: response_users } = await apiPost(
              api,
              resultData
            );
            if (status === 200) {
              if (response_users.status) {
                setBetFairObj({
                  ...betfairObj,
                  check: betSelectionObj?.layorback == "back" ? "Yes" : "No",
                  teamName: obj?.fancyName,
                  betPopup: false,
                });
                setBetPlacedCheck(true);
                setBetSelectionObj({
                  ...betSelectionObj,
                  priceToogle: false,
                });
                setIsBetPlaced("placed");
                setLoader(false);
                setMessageBox(true);
                amounutRefresh();
                // Log market to main panel (docs: add-market)
                try {
                  apiPost(apiPath.addMarket, {
                    type: "fancy",
                    market: {
                      tournamentId: obj?.tournamentId || obj?._id || "",
                      matchId: obj?.eventId || "",
                      matchName: obj?.matchName || obj?.eventName || "",
                      seriesId: obj?.seriesId || "",
                      eventId: obj?.eventId || "",
                      marketId: obj?.marketId || "",
                      centralizedId: obj?.centralizedId || `${obj?.eventId}S${obj?.selectionId}`,
                      selectionId: obj?.selectionId || "",
                      fancyId: obj?.marketId || obj?.fancyId || "",
                      fancyName: obj?.fancyName || obj?.marketName || "",
                      eventDateTime: obj?.eventDateTime || obj?.openDate || "",
                      marketCount: obj?.marketId || "",
                      jsonData: resultData,
                      marketType: obj?.marketType || 1,
                      categoryType: obj?.categoryType || 1,
                      status: "open",
                      runnerName: obj?.runnerName || "The Bet",
                    }
                  });
                } catch(e) {}
              } else {
                setBetFairObj({
                  ...betfairObj,
                  check: betSelectionObj?.layorback == "back" ? "Yes" : "No",
                  teamName: obj?.fancyName,
                  betPopup: false,
                });
                setBetPlacedCheck(true);
                setBetSelectionObj({
                  bidPrice: defaultStake ? defaultStake : "",
                  inputType: "",
                  betType: "",
                  oddsSelect: "",
                  priceToogleType: "",
                  priceToogle: false,
                  layorback: "",
                  minAmount: 1,
                  maxAmount: 100,
                  minAmountText: false,
                  expectany: defaultOdds,
                  gameType: "",
                  errorMessage: response_users?.message || response_users?.data?.message || "!",
                });
                setMessageBox(true);
                setBetLoader(false);
                setLoader(false);
                setIsBetPlaced("error");
              }
            } else {
              setBetFairObj({
                ...betfairObj,
                check: betSelectionObj?.layorback == "back" ? "Yes" : "No",
                teamName: obj?.fancyName,
                betPopup: false,
              });
              setBetSelectionObj({
                bidPrice: defaultStake ? defaultStake : "",
                inputType: "",
                betType: "",
                oddsSelect: "",
                priceToogleType: "",
                priceToogle: false,
                layorback: "",
                minAmount: 1,
                maxAmount: 100,
                minAmountText: false,
                expectany: defaultOdds,
                gameType: "",
                errorMessage: response_users?.message || response_users?.data?.message || "!",
              });
              setMessageBox(true);
              setBetLoader(false);
              setLoader(false);
              setIsBetPlaced("error");
            }
          // } else {
          //   setBetFairObj({
          //     ...betfairObj,
          //     check: betSelectionObj?.layorback == "back" ? "Yes" : "No",
          //     teamName: obj?.fancyName,
          //     betPopup: false,
          //   });
          //   setBetPlacedCheck(true);
          //   setBetSelectionObj({
          //     ...betSelectionObj,
          //     priceToogle: false,
          //     errorMessage: response_users2?.message,
          //   });
          //   setMessageBox(true);
          //   setBetLoader(false);
          //   setLoader(false);
          //   setIsBetPlaced("error");
          // }
        };
        // Use betDelay from obj parameter or default to loaderCount
        const delaySeconds = obj?.betDelay > 1 ? obj.betDelay : (loaderCount > 1 ? loaderCount : 1);
        setTimeout(
          () => {
            placeFunc();
          },
          (delaySeconds - 1) * 1000
        );
      }
    }
    setBetLoader(false);
  };
  useEffect(() => {
    if (Number(betSelectionObj.bidPrice) < Number(betSelectionObj.minAmount)) {
      setBetSelectionObj({ ...betSelectionObj, minAmountText: true });
    } else {
      setBetSelectionObj({ ...betSelectionObj, minAmountText: false });
    }
  }, [betSelectionObj?.bidPrice]);
  const handelAddMultiMarket = async (eventId) => {
    if (!isEmpty(user)) {
      setMultimarketLoader(true);
      const result = {
        eventId: eventId,
      };
      if (user) {
        const { status, data: response_users } = await apiPost(
          apiPath.multiMarket,
          result
        );
        if (status === 200) {
          if (response_users.success) {
            if (response_users.results.eventId) {
              setMultiMarketEventId(response_users.results.eventId);
              // setRunApi(!runApi);
              setMultimarketLoader(false);
            } else {
              setMultiMarketEventId(null);
              // setRunApi(!runApi);
              setMultimarketLoader(false);
            }
          } else {
            setMultimarketLoader(false);
            //toast.error(response_users.message);
          }
        }
      } else {
        setMultimarketLoader(false);
        // setShowLogin(true);
      }
    }
  };
  const handelPlaceBookmakerBet = async (obj) => {
    const date = moment(new Date()).format("YYYY-MM-DD, h:mm:ss");
    setLoader(true);
    console.log(betSelectionObj)
    const resultData = {
      eventId: obj.eventId,
      marketId: betSelectionObj?.bmi,
      selectionId: obj?.selectionId,
      // selectionId: obj?.sid,
      betPlaceTime: date,
      teamName: obj?.teamName,
      bhav: betSelectionObj?.oddsSelect,
      type: Number(obj?.eventType),
      amount: betSelectionObj.bidPrice,
      betType: betSelectionObj?.layorback,
      // exceptAny: betSelectionObj?.expectany,
      // betPlaceType: "bookmaker",
    };
    if (!isEmpty(user)) {
      const placeFunc = async () => {
        // const { data: response_users2 } = await apiPost(
        //   apiPath.beforeBetPlace,
        //   resultData
        // );
        // if (response_users2.success) {
          const { status, data: response_users } = await apiPost(
            apiPath.bookmakerBet,
            resultData
          );
          if (status === 200) {
            if (response_users.status) {
              setIsBetPlaced("placed");
              setBetFairObj({
                ...betfairObj,
                check: betSelectionObj?.layorback,
                teamName: obj?.teamName,
              });
              setBetPlacedCheck(true);
              setLoader(false);
              setBetSelectionObj({
                ...betSelectionObj,
                priceToogle: false,
              });
              setBetLoader(true);
              setMessageBox(true);
              amounutRefresh();
              setBetLoader(false);
              // toast.success(response_users.message);
            } else {
              setMessageBox(true);
              setBetLoader(false);
              setBetPlacedCheck(true);
              setLoader(false);
              setIsBetPlaced("error");
              setBetSelectionObj({
                ...betSelectionObj,
                priceToogle: false,
                errorMessage: response_users?.message || response_users?.data?.message || "!",
              });
              // toast.error(response_users.message);
            }
          } else {
            setBetFairObj({
              ...betfairObj,
              check: betSelectionObj?.layorback,
              teamName: obj?.teamName,
            });

            setBetSelectionObj({
              ...betSelectionObj,
              priceToogle: false,
              errorMessage: response_users?.message || response_users?.data?.message || "!",
            });
            setBetPlacedCheck(true);
            setLoader(false);
            setMessageBox(true);
            setIsBetPlaced("error");
          }
        // } else {
        //   setIsBetPlaced("error");
        //   setBetFairObj({
        //     ...betfairObj,
        //     check: betSelectionObj?.layorback,
        //     teamName: obj?.teamName,
        //   });
        //   setBetPlacedCheck(true);
        //   setLoader(false);
        //   setBetSelectionObj({
        //     ...betSelectionObj,
        //     priceToogle: false,
        //     errorMessage: response_users2?.message,
        //   });
        //   setBetLoader(true);
        //   setMessageBox(true);
        // }
      };
      // Use betDelay from obj parameter or default to loaderCount
      const delaySeconds = obj?.betDelay > 1 ? obj.betDelay : (loaderCount > 1 ? loaderCount : 1);
      setTimeout(
        () => {
          placeFunc();
        },
        (delaySeconds - 1) * 1000
      );
    }
    setBetLoader(false);
  };
  const handelPlacePreminumFancyBet = async (obj) => {
    const date = moment(new Date()).format("YYYY-MM-DD, h:mm:ss");
    setLoader(true);
    console.log(obj)
    const resultData = {
      eventId: String(obj.eventId),
      // marketId: obj?.marketId,
      marketId: obj?.marketList?.[0]?.marketId,
      fancySelectionId: obj?.selectId,
      selectionId: obj?.id,
      betPlaceTime: date,
      // runnerName:obj?.obj?.runnerName,
      fancyName: obj?.marketName,
      bhav: betSelectionObj?.oddsSelect,
      amount: Number(betSelectionObj.bidPrice),
      betType: "back",
      // exceptAny: betSelectionObj?.expectany,
      runnerName: obj?.obj?.selectionName,
      apiSiteSpecifier: obj?.apiSiteSpecifier,
      apiSiteSelectionId: Number(obj?.obj?.apiSiteSelectionId),
      eventType: Number(obj?.eventType),
      game_type: Number(obj?.eventType),
      version: "v1"
      // apiSiteSpecifier: obj?.newSelectId,
      // apiSiteSelectionId: obj?.newSelectId,
      // betPlaceType: "premiumFancy",
    };
    if (!isEmpty(user)) {
      const placeFunc = async () => {
        // const { data: response_users2 } = await apiPost(
        //   apiPath.beforeBetPlace,
        //   resultData
        // );
        // if (response_users2.success) {
          const { status, data: response_users } = await apiPost(
            apiPath.preminumFancyBets,
            resultData
          );
          if (status === 200) {
            if (response_users.status) {
              setIsBetPlaced("placed");
              setBetFairObj({
                ...betfairObj,
                check: "back",
                teamName: obj?.marketName,
                selectId: "",
              });
              setBetSelectionObj({
                ...betSelectionObj,
                priceToogle: false,
              });
              setBetPlacedCheck(true);
              setBetLoader(true);
              setMessageBox(true);
              setLoader(false);
              // Log market to main panel (docs: add-market)
              try {
                apiPost(apiPath.addMarket, {
                  type: "premium_fancy",
                  market: {
                    userId: user?.user?._id || "",
                    ipAddress: "",
                    matchName: obj?.matchName || "",
                    matchBetId: "",
                    matchId: obj?.eventId || "",
                    tournamentId: obj?.tournamentId || "",
                    seriesId: obj?.seriesId || "",
                    eventId: String(obj?.eventId || ""),
                    clientName: user?.user?.username || "",
                    marketId: `${obj?.eventId}S${obj?.selectId}`,
                    selectionId: obj?.selectId || "",
                    type: "back",
                    betType: "back",
                    amount: Number(betSelectionObj?.bidPrice),
                    bhav: betSelectionObj?.oddsSelect,
                    eventDateTime: new Date().toISOString(),
                    profitAmount: 0,
                    loseAmount: 0,
                    fancySelectionId: obj?.selectId || "",
                    apiSiteSelectionId: String(obj?.obj?.apiSiteSelectionId || ""),
                    exceptAny: "",
                    betBhav: betSelectionObj?.oddsSelect,
                    runnerName: obj?.obj?.selectionName || "",
                    fancyName: obj?.marketName || "",
                    apiSiteSpecifier: obj?.apiSiteSpecifier || "",
                    eventType: Number(obj?.eventType) || 4,
                    jsonData: resultData,
                    status: "active",
                    seriesName: "",
                    eventName: obj?.matchName || "",
                    scoreCard: "",
                  }
                });
              } catch(e) {}
              amounutRefresh();
              setBetLoader(false);
              // toast.success(response_users.message);
            } else {
              setMessageBox(true);
              setBetPlacedCheck(true);
              setBetLoader(false);
              setLoader(false);
              setIsBetPlaced("error");
              setBetFairObj({
                ...betfairObj,
                check: "back",
                teamName: obj?.marketName,
                selectId: "",
              });
              setBetSelectionObj({
                ...betSelectionObj,
                priceToogle: false,
                errorMessage: response_users?.message || response_users?.data?.message || "!",
              });
              // toast.error(response_users.message);
            }
          } else {
            // Handle 400 and other error status codes
            setMessageBox(true);
            setBetPlacedCheck(true);
            setBetLoader(false);
            setLoader(false);
            setIsBetPlaced("error");
            setBetFairObj({
              ...betfairObj,
              check: "back",
              teamName: obj?.marketName,
              selectId: "",
            });
            setBetSelectionObj({
              ...betSelectionObj,
              priceToogle: false,
              errorMessage: response_users?.message || response_users?.data?.message || "!",
            });
          }
        // } else {
        //   setMessageBox(true);
        //   setBetPlacedCheck(true);
        //   setBetLoader(false);
        //   setLoader(false);
        //   setIsBetPlaced("error");
        //   setBetFairObj({
        //     ...betfairObj,
        //     check: "back",
        //     teamName: obj?.marketName,
        //     selectId: "",
        //   });
        //   setBetSelectionObj({
        //     ...betSelectionObj,
        //     priceToogle: false,
        //     errorMessage: response_users2?.message,
        //   });
        // }
      };
      // Use betDelay from obj parameter or default to loaderCount
      const configuredDelay = Number(obj?.betDelay);
      const delaySeconds = obj?.betDelay != null && Number.isFinite(configuredDelay) && configuredDelay >= 0
        ? Math.max(1, configuredDelay)
        : (loaderCount > 1 ? loaderCount : 1);
      setTimeout(
        () => {
          placeFunc();
        },
        (delaySeconds - 1) * 1000
      );
    }
    setBetLoader(false);
  };
  useEffect(() => {
    if (betSelectionObj?.betType !== "" && betSelectionObj.gameType !== "") {
      var minAmount = profileData?.matchSetting?.find(
        (el) =>
          el.type ==
            (betSelectionObj?.betType == "betFair"
              ? "betFaire"
              : betSelectionObj?.betType == "bookmaker"
              ? "bookmaker"
              : betSelectionObj?.gameType == "fancy"
              ? "fancy"
              : "sportBook") && el.sportType == betSelectionObj?.gameType
      )?.minAmount;
      setBetSelectionObj({ ...betSelectionObj, minAmount: minAmount });
    }
  }, [
    betSelectionObj?.betType,
    betSelectionObj?.gameType,
    betSelectionObj?.bidPrice,
  ]);
  let contextData = {
    betLoader,
    handelAddMultiMarket,
    multimarketLoader,
    handelPlaceBetfair,
    setBetFairObj,
    setBetLoader,
    setMessageBox,
    messaageBox,
    setIsBetPlaced,
    isBetPlaced,
    betSelectionObj,
    setBetSelectionObj,
    betfairObj,
    handelPlaceBookmakerBet,
    handelPlaceFancyBet,
    handelPlacePreminumFancyBet,
    betPlacedCheck,
    setBetPlacedCheck,
    defaultStake,
    setDefaultStake,
    setDefaultOdds,
    defaultOdds,
    setBookPosition,
    bookposition,
    setBookPositionData,
    bookpositionData,
    unMatchedBets,
    refreshCurrentBet,
    setRefreshCurrentBets,
    handelPlaceBetfairUpdate,
    umMachedBetPlace,
    setUnMatchedBetPlace,
    setBetPlaceBeforeCheck,
    betPlaceBeforeCheck,
    setUpdatePosition,
    updatePosition,
    // matchLastOdds,
    // setMatchLastOdds,
    betDelay,
    handelPlaceToss,
    handelPlaceTie,
    setLoaderCount,
    // Add the amount refresh function to the context
    amountRefresh: amounutRefresh,
  };
  return (
    <BetSlipContext.Provider value={contextData}>
      {loading ? null : children}
    </BetSlipContext.Provider>
  );
};
